import styled from "@emotion/styled";
import { fontColor, FONTS } from "../../../styles/fonts";
import { responsivePlainTextStyles } from "../../../styles/text-styles";
import { richTextStyles } from "../../../styles/rich-text";

export const DescriptionRichText = styled.div`
  ${FONTS.SwarovskiFutura300};
  ${fontColor.black};

  ${responsivePlainTextStyles};
  ${richTextStyles};

  max-width: 760px;
  margin-left: 0;
  margin-right: auto;

  > p {
    margin-top: 0;
  }
`;
